<!--<div class="form-main">-->
<!--    <ul>-->
<!--        <li *ngFor="let item of textualContent; let n = index">-->
<!--            &lt;!&ndash;      <fa-icon size="lg" [ngClass]="{large: n === 0}" class="{{item.class}}" [icon]="item.icon"></fa-icon>&ndash;&gt;-->
<!--            <fa-icon [ngClass]="{lowOpacity: item?.legacy === true}" size="lg" class="{{item.class}}" [icon]="item.icon"></fa-icon>-->
<!--            <mat-label [ngClass]="{lowOpacity: item?.legacy === true}" (click)="download(item.type)" class="itemText">-->
<!--                <span [ngClass]="{large: n < 1}" class="downloadable ">{{item.h1}}</span>-->
<!--                <span *ngIf="item.extra" class="downloadable "></span>-->
<!--                <span *ngIf="item.extra" (click)="download(item.extra.type)" class="downloadable ">{{item.extra.h2}}</span>-->
<!--                <br/>-->
<!--                <div class="os-info-text">{{item.h2}}</div>-->
<!--            </mat-label>-->
<!--            <div *ngIf="n === 0">-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <br/>-->
<!--                <div fxLayout="column" fxLayoutAlign="center center" class="lowOpacity" style="position: relative; left: -100px">-->
<!--                    Legacy / previous versions-->
<!--                    <mat-icon>keyboard_arrow_down</mat-icon>-->
<!--                </div>-->
<!--            </div>-->
<!--    </ul>-->
<!--    <br/>-->
<!--    <br/>-->
<!--    <br/>-->
<!--</div>-->
<div class="form-main">
    <!--            <fa-icon size="xl" class="desktopIcon" [icon]="faTv"></fa-icon>-->
    <!--            <mat-label class="header ">Player</mat-label>-->
    <!--            <mat-divider></mat-divider>-->
    <ul>
<!--        <span class="minHead" style="text-align: center">Get the Digital Signage & Touch Studio</span>-->
        <div>
            <button mat-raised-button class="downloadMainBut" (click)="download('studio_web')" mat-button>
                <fa-icon size='lg' class="web" [icon]="faEdit"></fa-icon>
                <span style="font-size: 1.4em">Login to SignStudio</span>
            </button>
            <br/>
            <br/>
            <br/>
            <div class="os-info-text" style="opacity: 0.7">
                Web based Digital Signage & touch editor. You can also install the SignStudio directly onto your Desktop or Mobile device using the progressive web app (PWA).
            </div>
        </div>
        <br/>
        <br/>
        <br/>
        <mat-accordion>
            <!-- #docregion basic-panel -->
            <!-- #docregion hide-toggle -->
            <mat-expansion-panel hideToggle>
                <p>...</p>
            </mat-expansion-panel>
            <!-- #enddocregion basic-panel -->
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="minHead">Deprecated | previous version</span>
                    </mat-panel-title>
                    <mat-panel-description>
                        <!--                                Currently I am {{panelOpenState ? 'open' : 'closed'}}-->
                    </mat-panel-description>
                </mat-expansion-panel-header>
                get the previous version of the SignageStudio AIR
                <br/>
                <br/>
                <div>
                    <li>
                        <fa-icon size='lg' class="microsoft" [icon]="faMicrosoft"></fa-icon>
                        <mat-label (click)="download('studio_exe')" class="itemText"><span class="downloadable ">Get LegacyStudio Desktop exe</span><br/>
                            <!--                            <div class="os-info-text">Dedicated Desktop edition | Microsoft Windows (32/64 bit)</div>-->
                        </mat-label>
                    </li>
                    <li>
                        <fa-icon size='lg' class="apple" [icon]="faApple"></fa-icon>
                        <mat-label (click)="download('studio_dmg')" class="itemText"><span class="downloadable ">Get LegacyStudio Desktop dmg</span>
                            <!--                            <div class="os-info-text">Dedicated Mobile edition | Android</div>-->
                        </mat-label>
                    </li>
                    <li>
                        <fa-icon size='lg' class="watchdog" [icon]="faMicrosoft"></fa-icon>
                        <mat-label (click)="download('studio_air')" class="itemText"><span class="downloadable ">Get LegacyStudio Adobe Runtime air</span>
                            <!--                            <div class="os-info-text">for ADZ and Android 9.X</div>-->
                        </mat-label>
                    </li>
                    <li>
                        <fa-icon size='lg' class="apple" [icon]="faApple"></fa-icon>
                        <mat-label (click)="download('studio_air')" class="itemText"><span class="downloadable ">Get LegacyStudio air</span><br/>
                            <!--                            <div class="os-info-text">Mobile edition | Android 4.4+ | Updates from the Google store</div>-->
                        </mat-label>
                    </li>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </ul>
    <br/>
    <br/>
    <br/>
    <br/>
</div>

